<template>
  <b-card>
    <DeleteReasonsModal @refetch="fetchList" />
    <RemoveDeleteReasonModal
      :reason="toBeDeletedReason"
      @deleted="fetchList"
    />
    <b-button
      class="mb-1"
      variant="primary"
      @click="$bvModal.show('create-delete-reason-modal')"
    >
      Create New Delete Reason
    </b-button>
    <BaseOverlay
      :show="loading"
    >
      <b-table
        :fields="tableColumns"
        :items="list"
        striped
        hover
        responsive
        show-empty
        empty-text="No matching records found"
      >
        <template #cell(actions)="data">
          <b-button
            v-if="$can('delete', 'teams')"
            variant="flat-danger"
            @click="openDeleteReasonHandler(data.item)"
          >
            <feather-icon icon="TrashIcon" />
          </b-button>
        </template>
      </b-table>
    </BaseOverlay>
  </b-card>
</template>

<script>
import {
  BCard,
  BTable,
  BButton,
} from 'bootstrap-vue'
import {
  ref,
} from '@vue/composition-api'
import axiosIns from '@/libs/axios'
import BaseOverlay from '@/UI/BaseOverlay.vue'
import formatDate from '@/utils/date-format'
import DeleteReasonsModal from '../components/DeleteReasonsModal.vue'
import RemoveDeleteReasonModal from '../components/RemoveDeleteReasonModal.vue'

export default {
  components: {
    BCard,
    BTable,
    BButton,
    BaseOverlay,
    DeleteReasonsModal,
    RemoveDeleteReasonModal,
  },
  setup(_, ctx) {
    const tableColumns = [
      {
        label: 'Reason English',
        key: 'reasonEn',
        formatter: (_1, _2, item) => item.reason.en,
      },
      {
        label: 'Reason Arabic',
        key: 'reasonAr',
        formatter: (_1, _2, item) => item.reason.ar,
      },
      {
        key: 'createdAt',
        label: 'created at',
        formatter: val => formatDate(val),
      },
      'actions',
    ]
    const list = ref([])
    const loading = ref(false)

    const fetchList = async () => {
      loading.value = true

      const result = await axiosIns.get('/teams/delete-reasons')
      list.value = result.data.data
      loading.value = false
    }
    fetchList()

    const toBeDeletedReason = ref()
    const openDeleteReasonHandler = reason => {
      toBeDeletedReason.value = reason
      ctx.root.$bvModal.show('remove-delete-reason-modal')
    }
    return {
      loading,
      toBeDeletedReason,
      tableColumns,
      list,
      fetchList,
      openDeleteReasonHandler,
    }
  },
}
</script>

      <style></style>
